import { devtools } from 'config/devtools'
import { create } from 'zustand'

import { UseTransitionErrors } from './types'

export const useTransitionErrors = create<UseTransitionErrors>()(
  devtools(
    (set) => ({
      errors: [],
      clear: () => set({ errors: [] }),
      setErrors: (errors) => set({ errors }),
      removeError: (id, key) =>
        set(({ errors }) => ({ errors: errors.filter((item) => item.id !== id || item.key !== key) })),
      removeById: (id) => set(({ errors }) => ({ errors: errors.filter((item) => item.id !== id) })),
    }),
    {
      store: 'transitionErrors',
    },
  ),
)
